module.exports = "/_next/static/images/6bcbbd897b24bf082f0fc7290950166d-roxinho-card-with-phone-xs@1x.png";